import { combineReducers } from 'redux';
import voyagesDataReducer from './voyagesData/voyagesData.reducer';
import uiControlReducer from './uiControl/uiControl.reducer';
import shipLocationsReducer from './shipLocations/shipLocations.reducer';
import speciesDataReducer from './speciesData/speciesData.reducer';
import userReducer from './user/user.reducer';


const rootReducer = combineReducers({
  shipLocations: shipLocationsReducer,
  voyagesData: voyagesDataReducer,
  uiControl: uiControlReducer,
  speciesData: speciesDataReducer,
  user: userReducer,
});

export default rootReducer;
